import { render, staticRenderFns } from "./ediotable.vue?vue&type=template&id=bda864f0&scoped=true"
import script from "./ediotable.vue?vue&type=script&lang=js"
export * from "./ediotable.vue?vue&type=script&lang=js"
import style0 from "./ediotable.vue?vue&type=style&index=0&id=bda864f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda864f0",
  null
  
)

export default component.exports